export default "__VITE_ASSET__ad935d14__"